import { de_DE, en_US } from 'ng-zorro-antd/i18n';

export const getAntdLocale = (lang: string) => {
  // Potential TO-DO -- rewrite with dynamic imports() once we support > 5 locales
  switch (lang) {
    case 'en':
    default:
      return en_US;
    case 'de':
      return de_DE;
  }
};